import { ReactNode } from 'react';
import { ModalContextProvider as BaseModalContextProvider } from 'utils/contexts/modal';
import { DataSyncModalState } from './ModalContext';

type DataSyncModalContextProviderProps = {
  children: ReactNode;
};

export const DataSyncModalContextProvider = ({ children }: DataSyncModalContextProviderProps) => {
  return <BaseModalContextProvider<DataSyncModalState>>{children}</BaseModalContextProvider>;
};
